import { combineReducers } from 'redux';
import * as actionTypes from './actionTypes';

export const initialValues = {}

const deepLinkParamaters = (state = initialValues, action) => {
    switch (action.type) {
        case actionTypes.ADD_DEEP_LINK_PARAMS: {
            return {
                ...state,
                ...action.payload.params,
            }
        }
        case actionTypes.REMOVE_DEEP_LINK_PARAM: {
          const stateCopy = {
            ...state,
          };
          action.payload.keys.forEach((key) => {
            delete stateCopy[key];
          });
          return {
            ...stateCopy,
          }
        }
        default:
            return state;
    }
};

export default deepLinkParamaters;
